import { ContentWorkflow, WorkflowState } from '@amzn/awscat-pattern-library-service-model';
import React, { type JSX } from 'react';
import { withRouter } from 'react-router';
import constants from '../../common/constants';
import { withAppContext } from '../../contexts/AppContext';
import BrowserHistory from '../utils/BrowserHistory';
import DraftViewerRole from '../utils/DraftViewerRole';
import AuthorControls from './action-controls/AuthorControls';
import PublishingControls from './action-controls/PublishingControls';
import ContentViewer from './ContentViewer';

class AdminContentViewer extends ContentViewer {
  protected isEditingAllowed = true;
  protected showPublicationHistory = true;
  protected showSectionalComments = true;
  protected draftViewerRole = DraftViewerRole.Admin;
  protected isAdminView = true;
  protected showLastBarRaiserEvaluation: boolean = true;
  protected showPeerReviewInfo: boolean = true;

  protected showReviewFeedback = (workflow: ContentWorkflow | undefined) => {
    return workflow?.draftState !== WorkflowState.UNMODIFIED;
  };

  protected showContentControls = () => {
    const { workflow } = this.state;
    return !(
      [
        WorkflowState.IN_REVIEW,
        WorkflowState.REVIEWED,
        WorkflowState.PENDING_REVIEW,
        // @ts-expect-error TS18048 - strict migration
      ].includes(workflow.draftState) ||
      // @ts-expect-error TS18048 - strict migration
      [WorkflowState.FINALIZING].includes(workflow.publicationState)
    );
  };

  protected renderControls(): false | JSX.Element {
    const { workflow, content, validationError, submittingForReview } = this.state;
    const disabled = !!workflow && !!workflow.lock;

    // @ts-expect-error TS18048 - strict migration
    if (workflow.draftState === WorkflowState.REVIEWED) {
      return (
        <PublishingControls
          // @ts-expect-error TS18048 - strict migration
          contentId={workflow.contentId}
          workflow={workflow}
          onActionSuccess={this.navigateToDashboard}
          disabled={disabled}
        />
      );
    } else {
      return (
        <AuthorControls
          // @ts-expect-error TS18048 - strict migration
          contentId={workflow.contentId}
          content={content}
          workflow={workflow}
          disabled={submittingForReview || disabled}
          validationError={validationError}
          onActionSuccess={this.navigateToDashboard}
          loading={submittingForReview}
          readView
        />
      );
    }
  }

  // overrides method in WorkflowView
  protected getBreadcrumbItems(): Array<{ text: string; href: string }> {
    return [
      {
        href: '/admin/dashboard',
        text: constants.DASHBOARD,
      },
    ];
  }

  protected navigateBack = async () => {
    this.navigateToDashboard();
  };

  private navigateToDashboard = async () => {
    BrowserHistory.push('/admin/dashboard', { keepFlashbarMessages: true });
  };
}

export default withRouter(withAppContext(AdminContentViewer));
